import React from 'react';

import './Home.css';
import Typed from 'react-typed';

import About from '../../component/about/About';
import Services from '../../component/services/Services';
import FilterSome from '../../component/filter/FilterSome';
import Contact from '../../component/contact/Contact';

const Home = () => {
  return (
    <>
      <div className="home">
        <div class="blob">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 310 350"
          >
            <path d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z" />
          </svg>
        </div>
        <div className="black"></div>
        <div className="home-wrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-12 mb-3">
                <img src="image/atanu.jpg" alt="atanu" className="profileimg" />
              </div>
              <div className="col-md-6 col-12 d-block m-auto   ">
                <div className="hero-box">
                  <h2>Hello, I am </h2>
                  <h3 className="herotitle"> Atanu Jana </h3>

                  <h2>
                    And I am a&nbsp;
                    <Typed
                      strings={[
                        ' Web Developer',
                        ' Mern Stack Developer',
                        ' Full Stack Developer',
                        ' Freelancer',
                      ]}
                      typeSpeed={40}
                      backSpeed={50}
                      loop
                    />
                  </h2>
                  <a
                    href="https://internshala.com/student/resume_download/299B01F7-9D14-48BE-7C0B-E045D5FB21E4/8479523"
                    rel="noreferrer"
                    target="_blank"
                    className="btn btn-warning"
                  >
                    Download Cv
                  </a>

                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="social">
          <a
            href="https://www.facebook.com/profile.php?id=100026790454334"
            target="_blank"
            rel="noreferrer"
            className="vert-soc"
          >
            Facebook
          </a>
          <a
            href="https://github.com/atanu20"
            target="_blank"
            rel="noreferrer"
            className="vert-soc"
          >
            Github
          </a>
          <a
            href="https://www.linkedin.com/in/atanu-jana-0152ab1b0/"
            target="_blank"
            rel="noreferrer"
            className="vert-soc"
          >
            Linkedin
          </a>
        </div>
      </div>
      <About />
      <Services />
      <FilterSome />
      <Contact />
    </>
  );
};

export default Home;
